/**
 * 检查、检验报告   清单相关
 */
import http from "@/utils/axiosoUtil";

const mutations = {
  // 检验报告列表
  setInspectionsList(state, list) {
    state.inspectionsList = list;
  },
  // 检验报告详情
  setInspectionsDetailList(state, list) {
    state.inspectionDetailList = list;
  },
  // 每日清单日期列表
  setDailyListDate(state, list) {
    state.dailyListDates = list;
  },
  // 每日清单详情
  setDailyListDetail(state, list) {
    state.dailyListDetailList = list;
  }
};

const state = {
  inspectionsList: [],
  inspectionDetailList: [],
  dailyListDates: [],
  dailyListDetailList: []
};

const actions = {
  // 获取检验报告列表
  getInspectionsList({ commit }) {
    http.get(http.api.REPORT_INSPECTION_LIST).then(res => {
      const list = [];
      const year = "";
      let subItemList = [];
      const keys = Object.keys(res);
      for (let i = 0; i < keys.length; i += 1) {
        const item = res[keys[i]];
        const itemYear = item.billingDate.substr(0, 4);
        const subList = item.list.map(inspectionItem => {
          return {
            id: inspectionItem.sampleNo,
            title: inspectionItem.projectName
          };
        });
        const subItem = {
          date: item.billingDate,
          subItem: subList
        };
        subItemList.push(subItem);

        if (itemYear !== year) {
          list.push({
            year: itemYear,
            list: subItemList
          });
          subItemList = [];
        }
      }
      commit("setInspectionsList", list);
    });
  },
  // 获取检验报告列表
  getInspectionsDetail({ commit }) {
    http.get(http.api.REPORT_INSPECTION_DETAIL).then(res => {
      const list = res.map(item => {
        // 偏离度 0 不变 1 上升 -1 下降
        let departure = 0;
        if (item.normalValue === "↑") {
          departure = 1;
        }
        if (item.normalValue === "↓") {
          departure = -1;
        }
        return {
          name: item.projectName,
          value: item.inspectionResult,
          referenceRange: item.referenceRange,
          unit: item.jgdw00,
          departure
        };
      });
      commit("setInspectionsDetailList", list);
    });
  },
  // 获取每日清单日期数据
  getDailyListDates({ commit, dispatch }) {
    http.get(http.api.REPORT_DAILYLIST_DATE).then(res => {
      const list = res.map(item => {
        return {
          date: item.chargeDate,
          amount: item.selfTotal
        };
      });
      commit("setDailyListDate", list);
      dispatch("getDailyListDetail");
    });
  },
  // 获取清单详情
  getDailyListDetail({ commit }) {
    http.get(http.api.REPORT_DAILYLIST_DETAIL).then(res => {
      const list = res.map(item => {
        return {
          name: item.itemName
        };
      });
      commit("setDailyListDetail", list);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
